import { ChangeEvent, FC, ReactNode } from 'react'

const Input: FC<InputComponentProps> = (props): ReactNode => {
    const {
        id,
        label,
        placeholder,
        value,
        required,
        target,
        onChange,
        showError,
        validationFunction,
        disabled,
        type = 'text'
    } = props

    const validation: ValidationFunctionObjectReturnTypes = validationFunction(value)

    return (
        <div className='select-none sm:col-span-2' style={disabled ? { opacity: '0.75', pointerEvents: 'none' } : { opacity: '1', pointerEvents: 'auto' }}>
            <label htmlFor={id} className='select-none block mb-1 text-[13px] font-medium text-[#97999b]'>
                {label}

                {
                    required &&
                    <span className='text-red-400 ml-1 text-[12px]'>
                        *
                    </span>
                }
            </label>

            <input
                id={id}
                type={type}
                autoCapitalize='off'
                autoCorrect='off'
                autoComplete='off'
                spellCheck='false'
                value={value}
                disabled={disabled}
                onWheel={(e: React.WheelEvent<HTMLInputElement>) => e.currentTarget.blur()}
                placeholder={placeholder}
                className='bg-[#4A4A4A] border border-[#424242] placeholder:text-[#97999b] text-sm rounded-md text-[#EBEBEB] block w-full p-2.5'
                // @ts-ignore
                onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e?.target?.value, target)}
                onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
                    if (type === 'number' && !/^[0-9.]+$/.test(e.key)) {
                        e.preventDefault()
                    }
                }}
            />

            <p style={validation?.error && showError ? { opacity: '1' } : { opacity: '0' }} className='text-xs h-6 mt-[2px] ml-[2px] text-red-500 transition-all duration-500 ease-in-out'>
                {validation?.message}
            </p>
        </div>
    )
}

export default Input
